export const MAIN_CLASS_NAME = 'elma365-application-table';
export const SEARCH_CLASS_NAME = `${MAIN_CLASS_NAME}__search`;
export const CHECKBOX_CLASS_NAME = `${MAIN_CLASS_NAME}__checkbox`;

export const APPLICATION_PAGE_SIZE = 250;
